import { Component, OnInit } from '@angular/core';
import {StatesService} from '../../../utils/states.service';

@Component({
    selector: 'app-water',
    templateUrl: './water.component.html',
    styleUrls: ['./water.component.scss'],
    standalone: false
})
export class WaterComponent implements OnInit {

  constructor(public statesService: StatesService) { }

  ngOnInit(): void {
  }

}
